import {useEffect, useRef} from 'react';
const Dropdown =({countryList, jurisdictionObj, selectItem})=>{
	
	const dropdown = useRef(null);
	useEffect(()=>{
		if(dropdown.current){
			const objKey = Object.keys(jurisdictionObj)[0];
			const objVal = jurisdictionObj[Object.keys(jurisdictionObj)[0]];
			const countryDropdown = new MultiLayerDropdown(dropdown.current, {
		        searchPlaceholder: "Jurisdictions",
		        levels: ["Countries", "States"],
		        keys: ["country", "state"]
		    });
	    	countryDropdown.initializeData(countryList);
	    	countryDropdown.selectItems({
	    		[objKey]: [objVal]
	    	});

	    	(dropdown.current).addEventListener('itemSelect', (e)=>{
	    		const selectedVal = countryDropdown.getValues();
		        if (Object.keys(selectedVal).length > 0) {
		        	let key = Object.keys(selectedVal)[0];
		        	let val = selectedVal[key][0];
		        	selectItem({ [key]: val });
		        }
	    	})

		}
	},[countryList]);

	return (
		<div data-multi-select="false" ref={dropdown}></div>
	)
}

export default Dropdown;